import { ErroHttp } from '@/shared/utils/erroHttp';

/** O que o corpo de erro do core diz, nos dois formatos que ele usa (`error.*` ou raiz). */
export interface FalhaDaRespostaDoCore {
  mensagem: string;
  status: number;
  codigo: string | null;
  detalhes: unknown;
  /** O id que o core grava no log do erro: é o que liga o evento do RUM à linha do log. */
  errorEventId: string | null;
}

const erroHttpDa = (falha: FalhaDaRespostaDoCore): Error =>
  new ErroHttp(falha.mensagem, falha.status, null, falha.codigo);

/**
 * O `data` de uma resposta do core, ou o erro dela: por padrão um `ErroHttp` com o `error.code`,
 * que é o que separa causas distintas sob o mesmo status. Nasceu nas portas do AR (autorização e
 * envio físico, que só diferem no erro que lançam: a autorização precisa de `detalhes` e por isso
 * escolhe a classe) e foi para `shared` quando o uso de documento padrão no cadastro precisou dela.
 *
 * @example lerDadosDaRespostaDoCore<ListaEnviosFisicosArDto>(await apiGet(url), 'Não foi possível carregar')
 */
export async function lerDadosDaRespostaDoCore<T>(
  response: Response,
  mensagemDeErro: string,
  erroDa: (falha: FalhaDaRespostaDoCore) => Error = erroHttpDa,
): Promise<T> {
  if (!response.ok) {
    const corpo = await response.json().catch(() => null);
    throw erroDa({
      mensagem: corpo?.error?.message ?? corpo?.message ?? mensagemDeErro,
      status: response.status,
      codigo: corpo?.error?.code ?? corpo?.code ?? null,
      detalhes: corpo?.error?.details ?? corpo?.details ?? null,
      errorEventId: corpo?.error?.errorEventId ?? corpo?.errorEventId ?? null,
    });
  }
  const json = await response.json();
  return (json?.data ?? json) as T;
}
